import { render } from "./disclaimer.vue?vue&type=template&id=7c39f331"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=7c39f331&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__